export default {
  name: 'temperature',
  key: 'temperature',
  attributes: {
    frozen: {
      key: 'frozen',
      name: 'temperature.frozen',
    },
    cold: {
      key: 'cold',
      name: 'temperature.cold',
    },
    variableCold: {
      key: 'variableCold',
      name: 'temperature.variableCold',
    },
    temperate: {
      key: 'temperate',
      name: 'temperature.temperate',
    },
    variableWarm: {
      key: 'variableWarm',
      name: 'temperature.variableWarm',
    },
    warm: {
      key: 'warm',
      name: 'temperature.warm',
    },
    burning: {
      key: 'burning',
      name: 'temperature.burning',
    },
  },
};
